import React, { useEffect, useState } from 'react'

import Chat from './Chat'

import Canvas from './Canvas'

import {
  Grid,
  GridItem,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useMediaQuery,
} from '@chakra-ui/react'

import History from './History'
import BetControls from './BetControls'
import Players from './Players'
import Header from './Header'
import useLocalStorage from './useLocalStorage'
import AutoControls from './AutoControls'

export default function Layout() {
  const [isLargerThan1280] = useMediaQuery('(min-width: 992px)')
  const [tabIndex, setTabIndex] = useLocalStorage('preferredTab', 0)

  const handleTabsChange = index => {
    setTabIndex(index)
  }

  useEffect(() => {
    if (!isLargerThan1280) return
    if (tabIndex !== 2) return
    setTabIndex(0)
  }, [isLargerThan1280, tabIndex, setTabIndex])

  return (
    <Grid
      px="2"
      pb="2"
      bg=""
      h="100vh"
      minH="700px"
      templateColumns={
        isLargerThan1280
          ? 'repeat(3, minmax(0, 1fr))'
          : 'repeat(1, minmax(0, 1fr))'
      }
      templateRows={
        isLargerThan1280
          ? 'minmax(0, 50px) repeat(2, minmax(0, 1fr))'
          : 'minmax(0, 50px) repeat(3, minmax(0, 1fr))'
      }
      gap={3}
    >
      <GridItem colSpan={isLargerThan1280 ? 3 : 1} bg="">
        <Header />
      </GridItem>
      <GridItem colSpan={1} bg="" position="relative">
        <Canvas />
      </GridItem>
      <GridItem colSpan={1} bg="">
        <Tabs h="100%" colorScheme="orange" isFitted>
          <TabList>
            <Tab>Manual</Tab>
            <Tab isDisabled>Auto</Tab>
          </TabList>
          <TabPanels h="calc(100% - 42px)">
            <TabPanel h="100%">
              <BetControls />
            </TabPanel>
            <TabPanel h="100%">
              <AutoControls />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </GridItem>
      <GridItem
        minW="0"
        display={isLargerThan1280 ? 'block' : 'none'}
        rowSpan={2}
        colSpan={1}
        bg=""
        overflowY="auto"
      >
        <Players />
      </GridItem>

      <GridItem colSpan={isLargerThan1280 ? 2 : 1} bg="">
        <Tabs
          index={tabIndex}
          onChange={handleTabsChange}
          colorScheme="orange"
          h="100%"
          isFitted
        >
          <TabList>
            <Tab>Chat</Tab>
            <Tab>History</Tab>
            {!isLargerThan1280 && <Tab>Players</Tab>}
          </TabList>
          <TabPanels height="calc(100% - 42px)">
            <TabPanel h="100%" p="0">
              <Chat />
            </TabPanel>
            <TabPanel h="100%" overflowY="scroll" p="0">
              <History />
            </TabPanel>
            {!isLargerThan1280 && (
              <TabPanel h="100%" overflowY="scroll" p="0">
                <Players />
              </TabPanel>
            )}
          </TabPanels>
        </Tabs>
      </GridItem>
    </Grid>
  )
}
